// src/core/domain/health.js
//
// Pure classification of a health-probe result.

export const classifyHealthResult = ({ ok, status }) => {
  if (status === 0) return 'unreachable';
  if (ok) return 'operational';
  return 'degraded';
};